
import { BlogPost } from "@/types/blog";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

interface BlogPostPreviewProps {
  post: BlogPost;
}

const BlogPostPreview = ({ post }: BlogPostPreviewProps) => {
  return (
    <Card className="h-full flex flex-col">
      <div className="relative aspect-[16/9] overflow-hidden">
        <img
          src={post.image}
          alt={post.title}
          className="w-full h-full object-cover"
        />
      </div>
      <CardHeader>
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm text-muted-foreground">{post.date}</span>
          <span className="text-sm text-primary">{post.category}</span>
        </div>
        <h3 className="text-xl font-semibold line-clamp-2">{post.title}</h3>
        <p className="text-sm text-muted-foreground">By {post.author}</p>
      </CardHeader>
      <CardContent className="flex-grow">
        <p className="text-muted-foreground line-clamp-3">{post.excerpt}</p>
      </CardContent>
      <div className="p-6 pt-0">
        <Button asChild className="w-full">
          <Link to={`/blog/${post.id}`}>Read More</Link>
        </Button>
      </div>
    </Card>
  );
};

export default BlogPostPreview;
